import React from 'react'
import { useQuery } from '@apollo/client'
import { Form } from 'semantic-ui-react'
import { CREDENTIALS } from '../../../graphql/expert'

const Credentials = ({ credentials, setCredentials }) => {
  const { data, loading, error } = useQuery(CREDENTIALS, {
    context: { skipErrorDisplay: true },
  })

  const credentialOptions = (data?.credentials || []).map((credential) => ({
    key: credential,
    value: credential,
    text: credential,
  }))

  const dropdownDisabled = loading || !!error

  return (
    <Form.Dropdown
      label="Credentials"
      placeholder="Add all that apply from the dropdown"
      fluid
      multiple
      search
      selection
      loading={loading}
      disabled={dropdownDisabled}
      options={credentialOptions}
      value={credentials}
      onChange={(e, { value }) => setCredentials(value)}
      error={
        error
          ? {
              content: 'Unable to load credentials. Please try again.',
            }
          : null
      }
    />
  )
}

export default Credentials
